module.exports = window['.cfg'];